var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M200,91.94c0,5.46,0,10.92,0,16.38c-0.62,4.63-1.06,9.29-2.23,13.82c-9.72,37.85-33.24,62.65-70.54,74.33 c-6.15,1.93-12.53,2.76-18.92,3.53c-5.46,0-10.92,0-16.39,0c-4.63-0.63-9.27-1.17-13.83-2.21C24.55,185.59-9.81,132.68,2.5,78.05 c12.08-53.6,65.24-88.19,119.74-75.38c37.98,8.93,62.57,33.1,74.23,70.34C198.4,79.17,199.23,85.55,200,91.94z M72.98,100.13 c0,13.52,0,27.05,0,40.57c0,2.49,0.01,2.5,2.08,1.31c23.48-13.55,46.96-27.1,70.43-40.66c1.97-1.14,1.97-1.31,0-2.45 C122.01,85.35,98.53,71.8,75.05,58.25c-2.06-1.19-2.07-1.17-2.07,1.32C72.98,73.09,72.98,86.61,72.98,100.13z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/Play.5c150841deac6af740ee733bc226aa10.svg";
export { ForwardRef as ReactComponent };